import setStep from '../../../../api/deals/setStep';
import {
  DEAL_STATUS_CAR_DELIVERY,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import CarDelivery from '../CommonBankSteps/CarDelivery';
import CarRegistration from '../CommonBankSteps/CarRegistration';
import StepControlButtons from '../CommonBankSteps/StepControlButtons';

/**
 * Хвост сделки по Solva: регистрация ТС и выдача. Залоговых документов банк не
 * собирает — договор залога, заявление о постановке в залог и справку об
 * отсутствии налоговой задолженности у него не просят, поэтому общий экран
 * «Документы для постановки в залог» для Solva пропускается (см.
 * stepAfterNotarialDocuments).
 *
 * Своего API регистрации у Solva нет, в банк отсюда ничего не уходит: последним
 * запросом был CUSTOMER_ACCEPTED на шаге нотариальных документов. Дальше меняем
 * только статусы сделки.
 */
const SolvaFlow = ({ step, deal, update, loading, setLoading }) => {
  const onRegistrationSuccess = async () => {
    try {
      await setStep({ dealId: deal?.id, step: DEAL_STEPS.SOLVA.CAR_DELIVERY });
      update && update();
    } catch (e) {
      alert.error('Ошибка при смене шага сделки');
      setLoading(false);
    }
  };

  if (step === DEAL_STEPS.SOLVA.AUTO_REGISTRATION) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.NOTARIAL_DOCUMENTS}
          nextStep={DEAL_STEPS.SOLVA.CAR_DELIVERY}
          update={update}
          setLoading={setLoading}
        />
        <CarRegistration
          deal={deal}
          loading={loading}
          setLoading={setLoading}
          onSuccess={onRegistrationSuccess}
          statusOption={[
            {
              value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
              label: 'Ожидает постановки ТС на учет',
            },
            {
              value: DEAL_STATUS_CAR_DELIVERY,
              label: 'Машина поставлена на учет',
            },
          ]}
        />
      </>
    );
  }

  if (step === DEAL_STEPS.SOLVA.CAR_DELIVERY) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.SOLVA.AUTO_REGISTRATION}
          nextStep={DEAL_STEPS.FINISH}
          update={update}
          setLoading={setLoading}
        />
        <CarDelivery deal={deal} loading={loading} setLoading={setLoading} onSuccess={update} />
      </>
    );
  }

  return null;
};

export default SolvaFlow;
